import { useCallback, useState, type FormEvent } from 'react';

import { isValidEmail } from '@/utils/booking';

const NOT_LINKED_MESSAGE =
  "This email isn't linked to any transfer booking. Please verify and provide the correct one.";

export function useRecoverBookingReferenceModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmailState] = useState('');
  const [error, setError] = useState<string | null>(null);

  const setEmail = useCallback((value: string) => {
    setEmailState(value);
    setError(null);
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setEmailState('');
    setError(null);
  }, []);

  const submit = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      const trimmed = email.trim();
      if (!trimmed) {
        setError('Email is required');
        return;
      }
      if (!isValidEmail(trimmed)) {
        setError('Please enter a valid email address');
        return;
      }
      setError(NOT_LINKED_MESSAGE);
    },
    [email]
  );

  return {
    isOpen,
    email,
    setEmail,
    error,
    open,
    close,
    submit,
  };
}
